import { connect } from 'react-redux';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl
} from 'react-intl';
import { Button } from '@iwoca/orion';

import * as selectors from '../../accountsSelector';
import { ChevronLeftSVG } from '../../../../svgComponents/chevronLeftSVG/ChevronLeftSVG';
import { RocketSVG } from '../../../../svgComponents/rocketSVG/RocketSVG';
import { MoneyWithDecimals } from '../../../ui/moneyWithDecimals/MoneyWithDecimals';
import { Rate } from '../../../ui/rate/Rate';
import {
    DashboardActionTypes,
    TOP_UP_DRAWDOWN_ACTION
} from '../../../sharedDashboardComponents/LoanProgressBar/DashboardActions.types';

import styles from './DashboardActionPanel.module.css';
import messages from './DashboardActionPanel.messages';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { RootState } from '@iwProvider/configureStore';
import { TProductType } from '../../../../myAccount/dashboard/Dashboard.types';
import { TopUpPanel } from './TopUpPanel/TopUpPanel';

const mapStateToProps = (state: RootState) => {
    // TODO: Stop relying on the URL for the product type.
    let productType: TProductType = selectors.getProductTypeFromURL();
    if (getCountry() === 'DE' && productType === 'flexi24') {
        productType = 'credit_facility';
    }

    return {
        topupInterestRate: selectors.getLatestFormalOfferMonthlyInterestRate(
            state,
            productType
        ),
        creditLimit: selectors.getDrawdownCreditLimit(state, productType)
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const DashboardActionPanel = ({
    activeDashboardAction,
    showAllDashboardCTAs,
    topupInterestRate,
    creditLimit
}: {
    activeDashboardAction: DashboardActionTypes;
    showAllDashboardCTAs?: () => void;
} & PropsFromRedux &
    WrappedComponentProps) => {
    if (activeDashboardAction !== TOP_UP_DRAWDOWN_ACTION) return null;

    return (
        <>
            {showAllDashboardCTAs !== undefined && (
                <Button
                    variant="tertiary"
                    className={styles.backButton}
                    data-testid="action-panel-back-to-dashboard-actions"
                    onClick={showAllDashboardCTAs}
                >
                    <ChevronLeftSVG className={styles.backIcon} />

                    <FormattedMessage {...messages.goBackToDashboard} />
                </Button>
            )}

            <div className={styles.container}>
                <div className={styles.approvalSummaryIcon}>
                    <RocketSVG />
                </div>

                <span className={styles.approvalSummaryText}>
                    <FormattedMessage
                        {...messages.topUpApprovalSummary}
                        values={{
                            amount: (
                                <span className={styles.topupApprovedAmount}>
                                    <MoneyWithDecimals value={creditLimit} />
                                </span>
                            ),
                            interestRate: (
                                <span className={styles.topupInterestRate}>
                                    <Rate value={topupInterestRate} />
                                </span>
                            )
                        }}
                    />
                </span>
            </div>

            <TopUpPanel />
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(injectIntl(DashboardActionPanel));
